import { render, staticRenderFns } from "./FounderPeerGroups.vue?vue&type=template&id=27b44411&scoped=true&"
import script from "./FounderPeerGroups.vue?vue&type=script&lang=js&"
export * from "./FounderPeerGroups.vue?vue&type=script&lang=js&"
import style0 from "./FounderPeerGroups.vue?vue&type=style&index=0&id=27b44411&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b44411",
  null
  
)

export default component.exports